export default "__VITE_ASSET__DxwGrLVm__"